import React from 'react';
import {Typography} from "@mui/material";
import {styled} from "@mui/styles";

const Root = styled(Typography)(() => ({
  fontSize: '1rem',
  color: '#00000099'
}));

type GroupSummariesCardItemTitle = React.ComponentPropsWithoutRef<'h6'>;

/**
 * Styled Typography component to be used inside CardItem container and background for group summaries related components
 * @param props passthrough props to the internal Typography mui component
 * @constructor
 */
const GroupSummariesCardItemTitle = (props: GroupSummariesCardItemTitle) => {
  return <Root variant={'h6'} {...props} />
}

export { GroupSummariesCardItemTitle };
